import { createContext } from 'react';

// React context for draft state (draftId, companyId, user info, etc.).
const draftContext = createContext();

export default draftContext;
